import { Injectable } from '@angular/core';
import {
    Router,
    CanActivate,
    ActivatedRouteSnapshot
} from '@angular/router';
import { MessageBoxService } from './message-box.service';
import { LoginService } from './login.service';
@Injectable()
export class RoleGuardService implements CanActivate {

    constructor(public _loginService: LoginService, public _router: Router, private _messageBox: MessageBoxService) { }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        let expectedRole = route.data['admin'];
        const tokenRole = this._loginService.isAdmin();

        if (!this._loginService.isAuthenticated() || !expectedRole.find(x => x == tokenRole)) {
            this._messageBox.createMessageboxError("Du har ikke rettigheder til at se denne side.");
            this._router.navigate(['/public/login']);
            return false;
            }
            else{
                return true;
            }
    }
}
